import React, { useRef, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const LineChart = ({info}) => {
  const chartRef = useRef(null);
  const {adminLogsByMonth, customerLogsByMonth} = info
  const [chartData, setChartData] = useState({
    datasets: [],
  });

  const [clientData, setClientData] = useState([])
  const [adminData, setAdminData] = useState([])

  useEffect(() => {
    setAdminData(adminLogsByMonth)
    setClientData(customerLogsByMonth)
  }, [adminLogsByMonth])

  useEffect(() => {
    const chart = chartRef.current;

    if (!chart) {
      return;
    }


     
 

  const chartContext = chart.canvas.getContext("2d");

    const gradientStroke1 = chartContext.createLinearGradient(0, 230, 0, 50);
    gradientStroke1.addColorStop(1, "rgba(14, 60, 110, 0.5)");
    gradientStroke1.addColorStop(0.4, "rgba(27, 93, 150, 0.25)");
    gradientStroke1.addColorStop(0, "rgba(27, 93, 150, 0)");

    const gradientStroke2 = chartContext.createLinearGradient(0, 230, 0, 50);
    gradientStroke2.addColorStop(1, "rgba(116, 123, 124, 0.5)");
    gradientStroke2.addColorStop(0.4, "rgba(96, 99, 108, 0.25)");
    gradientStroke2.addColorStop(0, "rgba(96, 99, 108, 0)");

 



  setChartData({
    labels: ["Jan", "Feb", "March", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Admins",
        tension: 0.4,
        // borderWidth: 0,
        pointRadius: 0,
        borderColor: "#747B7C",
        borderWidth: 3,
        backgroundColor: gradientStroke1,
        fill: true,
        data: [adminData?.January?.length, adminData?.Feburary?.length, adminData?.March?.length, adminData?.April?.length, adminData?.May?.length, adminData?.June?.length, adminData?.July?.length, adminData?.August?.length, adminData?.September?.length, adminData?.October?.length, adminData?.November?.length, adminData?.December?.length],
        maxBarThickness: 6,
      },
      {
        label: "Clients",
        tension: 0.4,
        // borderWidth: 0,
        pointRadius: 0,
        borderColor: "#0E3C6E",
        borderWidth: 3,
        backgroundColor: gradientStroke2,
        fill: true,
        data: [clientData?.January?.length, clientData?.Feburary?.length, clientData?.March?.length, clientData?.April?.length, clientData?.May?.length, clientData?.June?.length, clientData?.July?.length, clientData?.August?.length, clientData?.September?.length, clientData?.October?.length, clientData?.November?.length, clientData?.December?.length],
        maxBarThickness: 6,
      },
    ],
  });
}, [adminData, clientData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    interaction: {
      intersect: false,
      mode: "index",
    },
    scales: {
      y: {
        grid: {
          drawBorder: false,
          display: true,
          drawOnChartArea: true,
          drawTicks: false,
          borderDash: [5, 5],
          color: "rgba(255, 255, 255, .2)",
        },
        ticks: {
          display: true,
          padding: 10,
          color: "#0E3C6E",
          font: {
            size: 11,
            family: "Open Sans",
            style: "normal",
            lineHeight: 2,
          },
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
          drawOnChartArea: false,
          drawTicks: false,
          borderDash: [5, 5],
        },
        ticks: {
          display: true,
          color: "#0E3C6E",
          padding: 20,
          font: {
            size: 11,
            family: "Open Sans",
            style: "normal",
            lineHeight: 2,
          },
        },
      },
    },
  };

  return <Line ref={chartRef} data={chartData} options={options} />;
};

export default LineChart;
